<template>
  <a-drawer
    title="线下门诊时间"
    placement="right"
    :closable="true"
    :maskClosable="false"
    :visible="settingVisible"
    :body-style="{ background: '#F6F7F8' }"
    :headerStyle="{ background: '#F6F7F8' }"
    @close="settingVisible = false"
    width="400"
  >
    <div class="content" v-if="submitData?.length">
      <div
        v-for="(item, $index) in submitData"
        :key="item.drOutpatientInfoId"
        :ref="el => (itemRefs[$index] = el)"
      >
        <Item
          :hospitalData="item"
          :submitData="submitData[$index]"
          @updateSchedule="data => updateSchedule(data, $index)"
          @deleteHospital="deleteHospital"
          @canSchedule="data => canSchedule(data, $index)"
        />
      </div>
      <div class="add_hosital" @click="_addHospital" v-if="hospitalList.length < maxSize">
        <PlusOutlined
          :style="{ fontSize: '15px', fontWeight: 'bold', marginRight: '4px', color: '#1890FF' }"
        />
        添加坐诊机构
      </div>
      <div class="notes">
        <div>复诊预约说明</div>
        <div>1. 医生和医助均可设置多个医院或者院区的门诊坐诊时间；</div>
        <div>2. 支持医生和医助修改复诊预约的开启关闭状态和门诊坐诊时间设置；</div>
        <div>3. 可以随时修改是否坐诊或停诊的时间，但开启或停诊不影响已经产生的预约单;</div>
        <div>4. 本平台预约复诊不代表门诊挂号，故患者还需到对应医院进行门诊预约挂号；</div>
        <div>
          5.
          如已对接医院号源接口的，无法编辑号源由系统对接更新排班，且患者可自行直接挂医院的门诊号源。
        </div>
      </div>
      <div class="footer">
        <a-button @click="settingVisible = false" class="cancle">取消</a-button>
        <a-button type="primary" @click="submitSetting" class="save">保存</a-button>
      </div>
    </div>
    <div v-else class="empty">
      <a-image width="160px" height="160px" :src="Empty" :preview="false" />
      <div class="add-hospital" @click="_addHospital">
        <PlusOutlined
          :style="{ fontSize: '12px', fontWeight: 'bold', marginRight: '4px', color: '#fff' }"
        />
        <span>添加坐诊机构</span>
      </div>
    </div>
  </a-drawer>
  <AddHospital ref="addHospitalRef" @updateHospital="updateHospitalList" />
</template>
<script setup>
import { ref, defineExpose, computed } from 'vue'
import { updateDrOutpatientInfo } from '@/api/workPlace/appoint'
import { message } from 'ant-design-vue'
import { REFRESH_SCHEDULE } from '@/views/WorkPlace/handleEventBuss'
import Item from './Item.vue'
import AddHospital from './addHospital.vue'
import useAppointSetting from './useAppointSetting'
import { getOutPatientList } from '@/api/chat'
import { PlusOutlined } from '@ant-design/icons-vue'
import Empty from '@/assets/img/empty-schedule.png'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'
const maxSize = ref(5) // 最大支持5个机构
const store = useStore()
const bindUcDoctorId = ref(undefined)
const doctorInfo = computed(() => store.state.workOrder.workOrderGroupInfo?.doctorInfo || {})
const ucDoctorId = computed(() => bindUcDoctorId.value || doctorInfo.value.ucUserId)

const { formatData, submitData, canSchedule, haveSchedule, itemRefs, addNewHospitalConfig } =
  useAppointSetting()
const addHospitalRef = ref(null)
const settingVisible = ref(false)
const hospitalList = ref([]) // 医生所有职业点
const loading = ref(false)
// 数据初始化
const settingInit = (params = {}) => {
  bindUcDoctorId.value = params?.bindUcDoctorId || ''
  settingVisible.value = true
  getHospitalList()
}

// 获取医生所有职业点
const getHospitalList = (refresh = true) => {
  if (!ucDoctorId.value) return
  refresh ? (loading.value = true) : ''
  getOutPatientList({
    ucDoctorId: ucDoctorId.value
  })
    .then(res => {
      const list = res || []
      const hisArr = list.filter(it => it.sourceType === 1) || []
      // 最大支持职业点数量，包含his排班
      maxSize.value = 5 - hisArr?.length || 0
      hospitalList.value = list.filter(it => it.sourceType !== 1) || []
      formatData(hospitalList.value)
    })
    .catch(() => {
      hospitalList.value = []
      submitData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
// 提交排班
const submitSetting = async () => {
  const beforeSubmit = await haveSchedule()
  if (!beforeSubmit) return
  const query = cloneDeep(submitData.value).map(item => {
    const consultationTime = {}
    const { weekOption } = item || {}

    weekOption.forEach((element, index) => {
      // 复诊预约开关 0 开 1 关
      consultationTime[index + 1 + ''] = [Number(element.morning), Number(element.evening), 0]
    })
    delete item.weekOption
    delete item.hospitalName
    delete item.firstHospitalFlag
    return {
      ...item,
      consultationTime: JSON.stringify(consultationTime)
    }
  })
  updateDrOutpatientInfo({ drOutpatientInfos: query }).then(res => {
    settingVisible.value = false
    message.success('保存成功！')
    REFRESH_SCHEDULE?.emit()
  })
}
// 新增机构
const _addHospital = () => {
  addHospitalRef?.value.initModal({
    historyList: hospitalList.value,
    ucDoctorId: ucDoctorId.value
  })
}
// 更新排班信息
const updateSchedule = (newData, index) => {
  const _submitData = submitData.value
  _submitData[index] = {
    ..._submitData[index],
    ...newData
  }
  submitData.value = _submitData
}
// 删除机构
const deleteHospital = drOutpatientInfoId => {
  hospitalList.value = hospitalList.value.filter(it => it.drOutpatientInfoId !== drOutpatientInfoId)
  submitData.value = submitData.value.filter(it => it.drOutpatientInfoId !== drOutpatientInfoId)
}
// 更新机构列表
const updateHospitalList = data => {
  REFRESH_SCHEDULE?.emit()
  hospitalList.value.push(data)
  addNewHospitalConfig(data)
}
defineExpose({
  settingInit
})
</script>

<style scoped lang="scss">
.content {
  overflow: hidden;
  height: 100%;
  // height: calc(100vh - 103px);
  padding-bottom: 100px;
  .mainSwitch {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px 8px;
    .main {
      flex: 1;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .info {
    font-size: 12px;
    color: #999999;
    text-indent: 8px;
    margin-bottom: 8px;
  }
  .add_hosital {
    cursor: pointer;
    width: 335px;
    height: 39px;
    background: #1890ff0a;
    border: 1px dashed #1890ffb3;
    border-radius: 8px;
    text-align: center;
    line-height: 39px;
    font-weight: 500;
    font-size: 14px;
    color: #1890ff;
    margin-bottom: 12px;
  }
  .notes {
    color: #999999;
    font-size: 13px;
    line-height: 20px;
  }
  .footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 15px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;

    .cancle {
      margin-right: 22px;
      height: 36px;
      font-size: 16px;
    }
    .save {
      width: 112px;
      height: 36px;
      font-size: 16px;
    }
  }
}
.empty {
  height: calc(100vh - 103px);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .add-hospital {
    margin: 30px 0 70px 0;
    line-height: 22px;
    cursor: pointer;
    background: #1890ff;
    border-radius: 4px;
    padding: 10px 20px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    width: fit-content;
  }
}
</style>
